import React, { ReactFragment } from "react"
import { ReactChild } from "react"
import styled from "styled-components"

interface Props {
  className?: string
  children?: ReactChild | ReactChild[]
}

export default function FormLabel(props: Props) {
  const { className, children } = props

  return <Label className={className}>{children}</Label>
}

const Label = styled.label`
  margin-bottom: 0px;
`
